// @flow
import * as actionTypes from './actionTypes';

export * from './filter';
export * from './profile';
export * from './issues';
export * from './modalWindow';
export * from './ui';
export * from './worklogs';
export * as actionTypes from './actionTypes';

export const setState = (
  keyOrRootValues,
  maybeValues,
) => ({
  type: actionTypes.SET_STATE,
  payload: {
    keyOrRootValues,
    maybeValues,
  },
});
